import { useInstancesByClassName } from 'hive-react-utils';
export function useCareTeamMembers() {
    return useInstancesByClassName('ecarepd', 'careTeamMember', {});
}
